'use strict';

app.service('HistoryAction', function () {
  this.format = function (action) {
    action.meta = action.meta || {};
    switch (action.name) {
      case 'module.introduction':
        action.icon = 'complete-lesson';
        action.title = 'You completed the ' + action.meta.label + ' Module Intro.';
        break;
      case 'module.quiz':
        var isPre = action.params.quizType == 'pre';
        action.icon = isPre ? 'complete-prequiz' : 'complete-postquiz';
        action.title = 'You completed the ' + action.meta.label + (isPre ? ' Pre' : ' Post') + ' Quiz.';
        break;
      case 'module.recap':
        action.icon = 'complete-module-recap-viewing';
        action.title = 'You completed the ' + action.meta.label + '.';
        break;
      case 'module.congratulations':
        action.icon = 'complete-module-congrats';
        action.title = 'You completed the ' + action.meta.label + '.';
        break;
      case 'module.lesson.recap':
        action.icon = 'complete-lesson-recap';
        action.title = 'You completed the ' + action.meta.label + '.';
        break;
      case 'module.lesson.introduction':
        action.icon = 'complete-lesson';
        action.title = 'You completed the ' + action.meta.label + ' Lesson Goals.';
        break;
      case 'module.lesson.byte':
        action.icon = 'complete-learning-byte';
        action.title = 'You completed the ' + action.meta.label + ' Learning Byte.';
        break;
      case 'module.lesson':
        action.icon = 'complete-module-congrats-viewing';
        action.title = 'You completed the ' + action.meta.label + ' Lesson.';
        break;
      case 'module':
        action.icon = 'complete-module-congrats-viewing';
        action.title = 'You completed the ' + action.meta.label + ' Module.';
        break;
      case 'instance.assessment':
        action.icon = 'update-user-profile';
        action.title = 'Congrats! You completed the ' + action.meta.label + ' Assessment Quiz.';
        break;
      case 'user.profile':
        action.icon = 'complete-user-profile';
        action.title = action.type == 'pass' ? 'You completed your profile.' : 'You updated your profile.';
        break;
      case 'user.registered':
        action.icon = 'complete-user-profile';
        action.title = 'You have been successfully registered.';
        break;
    }
    return action;
  };
});
